import smoothscroll from './utilities/smoothscroll.js';
import scrollPage from './utilities/scrollPage.js';
import backToTop from './utilities/backToTop.js';
import mobileMenu from './utilities/mobileMenu.js';

import 'jquery';
import 'jquery.easing';
import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'slick-carousel';

$(() => {
  smoothscroll();
  scrollPage();
  backToTop();
  mobileMenu();

  $('.js-slider').slick({
    fade: true,
    speed: 150,
    arrows: false,
    adaptiveHeight: true,
    swipe: false,
    slidesToShow: 1
  });
  $('.js-slider-nav').on('click', function(){
    $('.js-slider-nav').removeClass('is-active');
    $('.js-slider').slick('slickGoTo', $(this).attr('data-num'));
    $(this).addClass('is-active');
  });

  $('[data-fancybox="value"]').fancybox({
    toolbar  : false,
    infobar: false,
  	arrows   : false,
    btnTpl: {
      smallBtn: '<button class="page-philosophy_modal_close js-value-close" data-fancybox-close>Close</button>'
    },
  });
  $('.single_content').find('img').parent('a').fancybox({});


  $('.js-value-next').on('click', function() {
    $.fancybox.getInstance().next(200);
  });

  $('.js-value-prev').on('click', function() {
    $.fancybox.getInstance().previous(200);
  });
});



// WEBPACK FOOTER //
// ./src/assets/js/main.js